import { useState } from "react";
import { sb } from "../lib/supabase";

const REFUND_REASONS = ["Client requested refund", "Duplicate charge", "Service not rendered", "Billing error", "Other"];

export function RefundModal({ invoice, onClose, onSuccess, showToast }) {
  const [amount, setAmount]   = useState(Number(invoice.amount).toFixed(2));
  const [reason, setReason]   = useState(REFUND_REASONS[0]);
  const [saving, setSaving]   = useState(false);
  const [error,  setError]    = useState("");

  async function handleRefund() {
    if (!amount || Number(amount) <= 0)          { setError("Enter a valid amount"); return; }
    if (Number(amount) > Number(invoice.amount)) { setError(`Cannot refund more than $${Number(invoice.amount).toFixed(2)}`); return; }
    if (!invoice.stripe_payment_id)              { setError("No Stripe payment found — cannot issue refund automatically"); return; }
    if (!window.confirm(`Issue refund of $${Number(amount).toFixed(2)} to ${invoice.client_name}? This cannot be undone.`)) return;
    setSaving(true); setError("");
    try {
      const res = await sb.fn("issue-refund", {
        invoice_id:  invoice.id,
        client_id:   invoice.client_id,
        client_name: invoice.client_name,
        amount:      Number(amount),
        reason,
      });
      if (res.error) { setError(res.error); setSaving(false); return; }
      await onSuccess();
    } catch(e) { setError("Refund failed — check Stripe dashboard"); }
    setSaving(false);
  }

  return (
    <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal" style={{maxWidth:420}}>
        <div className="modal-header">
          <h3>↩ Issue Refund</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <div style={{background:"#f5f6f8",borderRadius:8,padding:"12px 14px",marginBottom:16}}>
            <div style={{fontWeight:600,fontSize:13}}>{invoice.client_name}</div>
            <div style={{fontSize:12,color:"#42526e",marginTop:2}}>{invoice.invoice_number} · Paid ${Number(invoice.amount).toFixed(2)}</div>
          </div>
          <div className="form-grid">
            <div className="form-group full">
              <label>Refund Amount ($)</label>
              <input type="number" step="0.01" min="0.01" max={invoice.amount} value={amount} onChange={e=>setAmount(e.target.value)}/>
              <div style={{fontSize:11,color:"#8993a4",marginTop:3}}>Max: ${Number(invoice.amount).toFixed(2)}</div>
            </div>
            <div className="form-group full">
              <label>Reason</label>
              <select value={reason} onChange={e=>setReason(e.target.value)}>
                {REFUND_REASONS.map(r=><option key={r} value={r}>{r}</option>)}
              </select>
            </div>
          </div>
          <div style={{background:"#fff8e1",border:"1px solid #ffd54f",borderRadius:6,padding:"8px 12px",marginTop:12,fontSize:12,color:"#e65100"}}>
            ⚠️ This will immediately refund ${Number(amount||0).toFixed(2)} to the client's card via Stripe. The invoice will be marked as refunded.
          </div>
          {error&&<div style={{background:"#ffebe6",border:"1px solid #ffbdad",borderRadius:6,padding:"8px 12px",fontSize:12,color:"#bf2600",marginTop:10}}>⚠️ {error}</div>}
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
          <button className="btn btn-danger" onClick={handleRefund} disabled={saving}>
            {saving?"Processing...":"Issue Refund"}
          </button>
        </div>
      </div>
    </div>
  );
}
